import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-video-modal',
    templateUrl: './video-modal.component.html',
    styles: [`
        .video-modal-player {
            background: #000;
            width: 100%;
            height: 400px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .video-modal-loading {
            text-align: center;
            color: #fff;
        }
        .video-modal-loading-text {
            margin-top: 8px;
        }
        .video-modal-element {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
        .video-modal-error {
            color: #fff;
            text-align: center;
        }
    `],
})
export class VideoModalComponent implements OnInit, OnDestroy {
    @Input() videoUrl?: string;

    /** v.qq.com → iframe 嵌入 */
    isIframeMode = false;
    iframeSrc?: SafeResourceUrl;

    /** .mp4 直链 / /download/video/ 下载链接 → <video> 播放 */
    isVideoMode = false;
    isLoading = false;
    hasError = false;
    videoSrc?: SafeResourceUrl;
    private blobUrl?: string;

    constructor(
        private http: HttpClient,
        private sanitizer: DomSanitizer
    ) { }

    ngOnInit(): void {
        if (!this.videoUrl) return;

        if (this.videoUrl.includes('v.qq.com')) {
            // 腾讯视频 - iframe 嵌入播放器页面
            this.isIframeMode = true;
            this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
        } else if (this.videoUrl.endsWith('.mp4')) {
            // 直链 MP4 - 直接作为 <video> 源
            this.isVideoMode = true;
            this.videoSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
        } else {
            // /download/video/ 等下载链接 - HTTP 获取 blob 后播放
            this.isVideoMode = true;
            this.isLoading = true;
            this.loadVideoAsBlob();
        }
    }

    private loadVideoAsBlob(): void {
        if (!this.videoUrl) return;

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'isUserCenterAdmin': 'true'
        });

        // 从完整 URL 中提取 /userCenterAdmin 之后的路径部分
        let apiUrl: string = this.videoUrl;
        const adminPathIndex = this.videoUrl.indexOf('/userCenterAdmin');
        if (adminPathIndex !== -1) {
            apiUrl = this.videoUrl.substring(adminPathIndex + '/userCenterAdmin'.length);
        } else {
            try {
                const urlObj = new URL(this.videoUrl);
                apiUrl = urlObj.pathname;
            } catch {
                // 如果不是完整 URL 则直接使用
            }
        }

        this.http.get(apiUrl, {
            headers: headers,
            responseType: 'blob'
        }).subscribe({
            next: (blob: Blob) => {
                const videoBlob = new Blob([blob], { type: 'video/mp4' });
                this.blobUrl = URL.createObjectURL(videoBlob);
                this.videoSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.blobUrl);
                this.isLoading = false;
            },
            error: () => {
                console.error('Error loading video:', this.videoUrl);
                this.hasError = true;
                this.isLoading = false;
            }
        });
    }

    onVideoError(): void {
        this.hasError = true;
    }

    ngOnDestroy(): void {
        if (this.blobUrl) {
            URL.revokeObjectURL(this.blobUrl);
        }
    }
}
